export default {
  title: 'Swiss Engineers United',
  sections: {
    cookies_banner_section: {
      fields: {
        field_one: {
          value: {
            title: 'SEU cookie popup & privacy policy',
            description: 'Your data is important to us. We use cookies to improve the use of our website for you and to analyze the traffic on our website. If you select "I agree", you consent to the use of analysis and marketing cookies on our website.',
            title2: 'Your choice:',
            buttonAccept: 'I agree',
            acceptDescription: 'Yes, I agree.',
            buttonReject: 'I decline',
            rejectDescription: 'No, thank you.',
            privacyLink: 'Privacy Policy'
          }
        },
      }
    },
  }
}
